module.exports = __webpack_public_path__ + "static/media/wsfs_login.b426139a.svg";